import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { environment } from '../environments/environment';

const newRelicOptions = {
  info: {
    applicationID: '1835182801',
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: 'NRBR-0498a5a413d103d00d0',
    sa: 1,
  },
  init: {
    ajax: {
      deny_list: [
        'bam.nr-data.net',
        'localhost',
        '127.0.0.1',
        '*.google.com',
        '*.googleapis.com',
        '*.gstatic.com',
        '*.google-analytics.com',
        '*.googletagmanager.com',
        '*.doubleclick.net',
        '*.googlesyndication.com',
        '*.googleadservices.com',
        '*.facebook.com',
        '*.facebook.net',
        '*.fbcdn.net',
      ],
    },
    browser_consent_mode: {
      enabled: false,
    },
    distributed_tracing: {
      enabled: true,
    },
    logging: {
      enabled: false,
    },
    performance: {
      capture_detail: false,
      capture_marks: false,
      capture_measures: true,
    },
    privacy: {
      cookies_enabled: true,
    },
  },
  loader_config: {
    accountID: '8243082',
    agentID: '1835182801',
    applicationID: '1835182801',
    licenseKey: 'NRBR-0498a5a413d103d00d0',
    trustKey: '1856993',
  },
};

let agent: BrowserAgent | null = null;

export function initNewRelic(): void {
  if (!environment.newRelicEnabled || agent) {
    return;
  }

  agent = new BrowserAgent(newRelicOptions);
}

export function getNewRelicAgent(): BrowserAgent | null {
  return agent;
}
